export const days = state => {
    return state.days
}

export const date = state => {
    return state.date
}

export const element = state => {
    return state.element
}



// WEBPACK FOOTER //
// ./src/store/modules/hairRegimen/getters.js